import React from 'react';

import { Skeleton } from 'antd';

export default function SkeletonContainer({ children, loading = false }) {
  return <>{loading ? <Skeleton active /> : children}</>;
}
